if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"pmc","remotes":[]},
		chunkMatcher: function(chunkId) {return !/^(8(10|775|884)|(614|626|999)5|297|3454|4106|5120)$/.test(chunkId)},
		rootOutputDir: "../../",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}